import { render, staticRenderFns } from "./BINCardRelatedItem.vue?vue&type=template&id=83cb0840&lang=pug&"
import script from "./BINCardRelatedItem.vue?vue&type=script&lang=js&"
export * from "./BINCardRelatedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports